import React from 'react'
import "./ScentPhiloPage.css"

const ScentPhiloHead = () => {
  return (
    <div className='scentPhiloHeadContainer'>
      <h1 className='philoHead'>SCENT Philosophy</h1>
      <div className="philoUnderline"></div>
    </div>
  )
}

export default ScentPhiloHead
